import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { cn } from '@/lib/utils';

interface ToggleSwitchProps {
  isChecked: boolean;
  onToggle: () => void;
  isDisabled?: boolean;
  isPending?: boolean;
  accessibleLabel: string;
}

export function ToggleSwitch({
  isChecked,
  onToggle,
  isDisabled = false,
  isPending = false,
  accessibleLabel,
}: ToggleSwitchProps) {
  const isInteractionDisabled = isDisabled === true || isPending === true;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      aria-label={accessibleLabel}
      aria-busy={isPending === true ? true : undefined}
      disabled={isInteractionDisabled}
      onClick={onToggle}
      className={cn(
        'w-11 h-6 rounded-full relative transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary focus-visible:ring-offset-2',
        isChecked ? 'bg-zooprimary' : 'bg-zooborder',
        isInteractionDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
      )}
    >
      {isPending === true ? (
        <LoadingSpinner
          className={cn(
            'absolute top-1 w-4 h-4 border-zoowhite border-t-transparent',
            isChecked ? 'right-1' : 'left-1'
          )}
        />
      ) : (
        <span
          className={cn(
            'absolute top-1 w-4 h-4 bg-zoowhite rounded-full transition-all',
            isChecked ? 'right-1' : 'left-1'
          )}
        />
      )}
    </button>
  );
}
